/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListOperations200ResponseItemsInnerPeriod } from './ListOperations200ResponseItemsInnerPeriod';
import {
    ListOperations200ResponseItemsInnerPeriodFromJSON,
    ListOperations200ResponseItemsInnerPeriodFromJSONTyped,
    ListOperations200ResponseItemsInnerPeriodToJSON,
    ListOperations200ResponseItemsInnerPeriodToJSONTyped,
} from './ListOperations200ResponseItemsInnerPeriod';

/**
 * 精算書一覧のアイテム
 * @export
 * @interface ListStatements200ResponseItemsInner
 */
export interface ListStatements200ResponseItemsInner {
    /**
     * ID
     * @type {string}
     * @memberof ListStatements200ResponseItemsInner
     */
    id: string;
    /**
     * 対象サービス（service_category）
     * @type {number}
     * @memberof ListStatements200ResponseItemsInner
     */
    serviceCategory: ListStatements200ResponseItemsInnerServiceCategoryEnum | null;
    /**
     * 会社名
     * @type {string}
     * @memberof ListStatements200ResponseItemsInner
     */
    companyName: string;
    /**
     * 会社ID
     * @type {string}
     * @memberof ListStatements200ResponseItemsInner
     */
    companyId: string;
    /**
     * 発行日
     * @type {Date}
     * @memberof ListStatements200ResponseItemsInner
     */
    issuedDate: Date;
    /**
     * 
     * @type {ListOperations200ResponseItemsInnerPeriod}
     * @memberof ListStatements200ResponseItemsInner
     */
    paymentPeriod: ListOperations200ResponseItemsInnerPeriod;
    /**
     * 合計金額
     * @type {number}
     * @memberof ListStatements200ResponseItemsInner
     */
    totalAmount: number;
}


/**
 * @export
 */
export const ListStatements200ResponseItemsInnerServiceCategoryEnum = {
    OVERSEAS_ROAMING: 0
} as const;
export type ListStatements200ResponseItemsInnerServiceCategoryEnum = typeof ListStatements200ResponseItemsInnerServiceCategoryEnum[keyof typeof ListStatements200ResponseItemsInnerServiceCategoryEnum];


/**
 * Check if a given object implements the ListStatements200ResponseItemsInner interface.
 */
export function instanceOfListStatements200ResponseItemsInner(value: object): value is ListStatements200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('serviceCategory' in value) || value['serviceCategory'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('issuedDate' in value) || value['issuedDate'] === undefined) return false;
    if (!('paymentPeriod' in value) || value['paymentPeriod'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    return true;
}

export function ListStatements200ResponseItemsInnerFromJSON(json: any): ListStatements200ResponseItemsInner {
    return ListStatements200ResponseItemsInnerFromJSONTyped(json, false);
}

export function ListStatements200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListStatements200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'serviceCategory': json['service_category'],
        'companyName': json['company_name'],
        'companyId': json['company_id'],
        'issuedDate': (new Date(json['issued_date'])),
        'paymentPeriod': ListOperations200ResponseItemsInnerPeriodFromJSON(json['payment_period']),
        'totalAmount': json['total_amount'],
    };
}

export function ListStatements200ResponseItemsInnerToJSON(json: any): ListStatements200ResponseItemsInner {
    return ListStatements200ResponseItemsInnerToJSONTyped(json, false);
}

export function ListStatements200ResponseItemsInnerToJSONTyped(value?: ListStatements200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'service_category': value['serviceCategory'],
        'company_name': value['companyName'],
        'company_id': value['companyId'],
        'issued_date': ((value['issuedDate']).toISOString().substring(0,10)),
        'payment_period': ListOperations200ResponseItemsInnerPeriodToJSON(value['paymentPeriod']),
        'total_amount': value['totalAmount'],
    };
}

